import React from 'react';
import { Phone, ChefHat, Users, Calendar, Utensils, GlassWater, MessageCircle, Truck, Heart } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';

const traiteurImages = [
  "https://customer-assets.emergentagent.com/job_urbanafrofood/artifacts/49ohujh2_African-Dream-WhatsApp-Image-2025-11-14-at-00-23-23-jpeg.jpg",
  "https://customer-assets.emergentagent.com/job_urbanafrofood/artifacts/vixqlkvo_African-Dream-WhatsApp-Image-2025-11-14-at-00-23-23-1-jpeg.jpg",
  "https://customer-assets.emergentagent.com/job_urbanafrofood/artifacts/wuhycr3z_African-Dream-WhatsApp-Image-2025-11-14-at-00-23-23-2-jpeg.jpg",
  "https://customer-assets.emergentagent.com/job_urbanafrofood/artifacts/rsw26wdw_African-Dream-WhatsApp-Image-2025-11-14-at-00-23-20-jpeg.jpg",
  "https://customer-assets.emergentagent.com/job_urbanafrofood/artifacts/dgv5rcfv_African-Dream-WhatsApp-Image-2025-11-14-at-00-14-25-2-jpeg.jpg"
];

const TraiteurPage = () => {
  return (
    <div className="min-h-screen bg-[#0F0F0F]">
      {/* Hero Section */}
      <section 
        className="relative min-h-[70vh] flex items-center justify-center bg-cover bg-center"
        style={{
          backgroundImage: `url(${traiteurImages[0]})`
        }}
      >
        <div className="absolute inset-0 bg-black/70"></div>
        <div className="relative z-10 max-w-5xl mx-auto px-4 text-center py-32">
          <img
            src="/african-dream-logo.png"
            alt="AFRICAN DREAM Logo"
            className="w-[300px] md:w-[450px] lg:w-[550px] h-auto mx-auto mb-8"
          />
          <h1 
            className="text-4xl md:text-5xl font-bold text-[#D4A85F] mb-4"
            style={{ fontFamily: "'Crimson Text', serif" }}
          >
            Traiteur Africain
          </h1>
          <p 
            className="text-xl text-white max-w-3xl mx-auto"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            Une cuisine authentique pour vos événements
          </p>
        </div>
      </section>

      {/* Introduction Section */}
      <section className="py-20 bg-[#1A1A1A]">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 
            className="text-4xl md:text-5xl font-bold text-[#D4A85F] mb-8"
            style={{ fontFamily: "'Crimson Text', serif" }}
          >
            AFRICAN DREAM – Traiteur Africain
          </h2>
          <div className="space-y-6 text-gray-300 text-lg leading-relaxed" style={{ fontFamily: "'Poppins', sans-serif" }}>
            <p>
              <span className="text-[#D4A85F] font-semibold">AFRICAN DREAM</span>, c'est bien plus qu'un simple service traiteur.
              C'est l'envie de faire voyager vos invités à travers une cuisine africaine authentique, généreuse et conviviale, préparée avec passion et savoir-faire.
            </p>
            <p>
              Que ce soit pour un événement familial ou professionnel, nous vous accompagnons avec des plats faits maison, pensés pour être partagés et appréciés par tous.
            </p>
            <p>
              <span className="text-white font-semibold">Mariage, anniversaire, fête de famille ou événement d'entreprise</span> : AFRICAN DREAM s'adapte à votre événement, à vos envies et à votre budget.
            </p>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-20 bg-[#0F0F0F]">
        <div className="max-w-7xl mx-auto px-4">
          <h2 
            className="text-4xl md:text-5xl font-bold text-[#3ABEFF] mb-16 text-center"
            style={{ fontFamily: "'Crimson Text', serif" }}
          >
            Nos Prestations Traiteur
          </h2>

          <div className="grid md:grid-cols-2 gap-8 mb-16">
            {/* Cuisine africaine traditionnelle */}
            <Card className="bg-[#1A1A1A] border-[#D4A85F]/30 border shadow-xl hover:border-[#D4A85F] transition-colors">
              <CardHeader>
                <CardTitle className="flex items-center gap-3 text-2xl text-[#D4A85F]" style={{ fontFamily: "'Crimson Text', serif" }}>
                  <div className="bg-[#D4A85F] p-3 rounded-full">
                    <ChefHat className="text-black" size={28} />
                  </div>
                  Cuisine africaine traditionnelle
                </CardTitle>
              </CardHeader>
              <CardContent>
                <ul className="space-y-2 text-gray-300" style={{ fontFamily: "'Poppins', sans-serif" }}>
                  <li className="flex items-center gap-2"><span className="text-[#D4A85F]">•</span> Thieb (poulet ou poisson)</li>
                  <li className="flex items-center gap-2"><span className="text-[#D4A85F]">•</span> Yassa poulet</li>
                  <li className="flex items-center gap-2"><span className="text-[#D4A85F]">•</span> Mafé (bœuf ou poulet)</li>
                  <li className="flex items-center gap-2"><span className="text-[#D4A85F]">•</span> Poulet braisé / rôti</li>
                  <li className="flex items-center gap-2"><span className="text-[#D4A85F]">•</span> Plats mijotés africains</li>
                  <li className="flex items-center gap-2"><span className="text-[#D4A85F]">•</span> Riz, légumes, sauces maison</li>
                </ul>
                <p className="text-sm text-gray-400 mt-4 italic">Préparés en grandes quantités, idéal pour le partage.</p>
              </CardContent>
            </Card>

            {/* Buffets & plats à partager */}
            <Card className="bg-[#1A1A1A] border-[#D4A85F]/30 border shadow-xl hover:border-[#D4A85F] transition-colors">
              <CardHeader>
                <CardTitle className="flex items-center gap-3 text-2xl text-[#D4A85F]" style={{ fontFamily: "'Crimson Text', serif" }}>
                  <div className="bg-[#D4A85F] p-3 rounded-full">
                    <Users className="text-black" size={28} />
                  </div>
                  Buffets & plats à partager
                </CardTitle>
              </CardHeader>
              <CardContent>
                <ul className="space-y-2 text-gray-300" style={{ fontFamily: "'Poppins', sans-serif" }}>
                  <li className="flex items-center gap-2"><span className="text-[#D4A85F]">•</span> Buffets africains</li>
                  <li className="flex items-center gap-2"><span className="text-[#D4A85F]">•</span> Grands plats familiaux</li>
                  <li className="flex items-center gap-2"><span className="text-[#D4A85F]">•</span> Plateaux traiteur</li>
                  <li className="flex items-center gap-2"><span className="text-[#D4A85F]">•</span> Service sur mesure selon le nombre de convives</li>
                </ul>
              </CardContent>
            </Card>

            {/* Événements couverts */}
            <Card className="bg-[#1A1A1A] border-[#D4A85F]/30 border shadow-xl hover:border-[#D4A85F] transition-colors">
              <CardHeader>
                <CardTitle className="flex items-center gap-3 text-2xl text-[#D4A85F]" style={{ fontFamily: "'Crimson Text', serif" }}>
                  <div className="bg-[#D4A85F] p-3 rounded-full">
                    <Calendar className="text-black" size={28} />
                  </div>
                  Événements couverts
                </CardTitle>
              </CardHeader>
              <CardContent>
                <ul className="space-y-2 text-gray-300" style={{ fontFamily: "'Poppins', sans-serif" }}>
                  <li className="flex items-center gap-2"><span className="text-[#D4A85F]">•</span> Mariages</li>
                  <li className="flex items-center gap-2"><span className="text-[#D4A85F]">•</span> Anniversaires</li>
                  <li className="flex items-center gap-2"><span className="text-[#D4A85F]">•</span> Baptêmes</li>
                  <li className="flex items-center gap-2"><span className="text-[#D4A85F]">•</span> Fêtes familiales</li>
                  <li className="flex items-center gap-2"><span className="text-[#D4A85F]">•</span> Événements d'entreprise</li>
                  <li className="flex items-center gap-2"><span className="text-[#D4A85F]">•</span> Associations & collectivités</li>
                </ul>
              </CardContent>
            </Card>

            {/* Location de vaisselle */}
            <Card className="bg-[#D4A85F] border-none shadow-xl">
              <CardHeader>
                <CardTitle className="flex items-center gap-3 text-2xl text-black" style={{ fontFamily: "'Crimson Text', serif" }}>
                  <div className="bg-black p-3 rounded-full">
                    <GlassWater className="text-[#D4A85F]" size={28} />
                  </div>
                  Location de vaisselle
                </CardTitle>
              </CardHeader>
              <CardContent>
                <ul className="space-y-2 text-gray-800" style={{ fontFamily: "'Poppins', sans-serif" }}>
                  <li className="flex items-center gap-2"><span className="text-black">•</span> Assiettes entrée</li>
                  <li className="flex items-center gap-2"><span className="text-black">•</span> Assiettes plat</li>
                  <li className="flex items-center gap-2"><span className="text-black">•</span> Assiettes dessert</li>
                  <li className="flex items-center gap-2"><span className="text-black">•</span> Couverts</li>
                  <li className="flex items-center gap-2"><span className="text-black">•</span> Verres à eau</li>
                  <li className="flex items-center gap-2"><span className="text-black">•</span> Verres à vin</li>
                  <li className="flex items-center gap-2"><span className="text-black">•</span> Flûtes de champagne</li>
                </ul>
                <p className="text-sm text-gray-700 mt-4 font-semibold">Service idéal pour événements clés en main.</p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="py-20 bg-[#1A1A1A]">
        <div className="max-w-7xl mx-auto px-4">
          <h2 
            className="text-4xl md:text-5xl font-bold text-[#3ABEFF] mb-16 text-center"
            style={{ fontFamily: "'Crimson Text', serif" }}
          >
            Nos Réalisations
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {traiteurImages.map((image, idx) => (
              <div
                key={idx}
                className="group relative overflow-hidden rounded-lg shadow-xl aspect-square cursor-pointer transition-all duration-300 hover:transform hover:scale-105"
              >
                <img
                  src={image}
                  alt={`Réalisation traiteur ${idx + 1}`}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* How it Works Section */}
      <section className="py-20 bg-[#0F0F0F]">
        <div className="max-w-5xl mx-auto px-4">
          <h2 
            className="text-4xl md:text-5xl font-bold text-[#3ABEFF] mb-16 text-center"
            style={{ fontFamily: "'Crimson Text', serif" }}
          >
            Comment ça marche ?
          </h2>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="bg-[#D4A85F] w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6">
                <MessageCircle className="text-black" size={36} />
              </div>
              <div className="bg-[#D4A85F] text-black text-2xl font-bold w-10 h-10 rounded-full flex items-center justify-center mx-auto mb-4">1</div>
              <h3 className="text-xl font-bold text-white mb-3" style={{ fontFamily: "'Crimson Text', serif" }}>Vous nous contactez</h3>
              <p className="text-gray-400" style={{ fontFamily: "'Poppins', sans-serif" }}>Par téléphone ou message pour nous parler de votre projet</p>
            </div>
            <div className="text-center">
              <div className="bg-[#D4A85F] w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6">
                <Heart className="text-black" size={36} />
              </div>
              <div className="bg-[#D4A85F] text-black text-2xl font-bold w-10 h-10 rounded-full flex items-center justify-center mx-auto mb-4">2</div>
              <h3 className="text-xl font-bold text-white mb-3" style={{ fontFamily: "'Crimson Text', serif" }}>Nous définissons ensemble</h3>
              <p className="text-gray-400" style={{ fontFamily: "'Poppins', sans-serif" }}>Votre événement, vos envies, votre budget</p>
            </div>
            <div className="text-center">
              <div className="bg-[#D4A85F] w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6">
                <Truck className="text-black" size={36} />
              </div>
              <div className="bg-[#D4A85F] text-black text-2xl font-bold w-10 h-10 rounded-full flex items-center justify-center mx-auto mb-4">3</div>
              <h3 className="text-xl font-bold text-white mb-3" style={{ fontFamily: "'Crimson Text', serif" }}>Nous préparons et livrons</h3>
              <p className="text-gray-400" style={{ fontFamily: "'Poppins', sans-serif" }}>Votre prestation traiteur, prête à être dégustée</p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact CTA Section */}
      <section className="py-20 bg-[#D4A85F]">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 
            className="text-4xl md:text-5xl font-bold text-black mb-6"
            style={{ fontFamily: "'Crimson Text', serif" }}
          >
            Demande de devis traiteur
          </h2>
          <p 
            className="text-xl text-gray-800 mb-10"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            Contactez-nous pour un devis personnalisé selon votre événement.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a
              href="tel:+33768304656"
              className="inline-flex items-center gap-3 bg-black text-white px-8 py-4 rounded-md font-bold text-lg hover:bg-gray-900 transition-all duration-200 hover:transform hover:-translate-y-1 hover:shadow-xl"
              style={{ fontFamily: "'Poppins', sans-serif" }}
            >
              <Phone size={24} />
              07 68 30 46 56
            </a>
            <a
              href="tel:+33169307853"
              className="inline-flex items-center gap-3 bg-black text-white px-8 py-4 rounded-md font-bold text-lg hover:bg-gray-900 transition-all duration-200 hover:transform hover:-translate-y-1 hover:shadow-xl"
              style={{ fontFamily: "'Poppins', sans-serif" }}
            >
              <Phone size={24} />
              01 69 30 78 53
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-black text-white py-12">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <img
            src="/african-dream-logo.png"
            alt="AFRICAN DREAM Logo"
            className="h-32 md:h-40 w-auto mx-auto mb-6"
          />
          <p 
            className="text-[#D4A85F] text-xl font-semibold mb-4"
            style={{ fontFamily: "'Crimson Text', serif" }}
          >
            AFRICAN DREAM – Traiteur Africain
          </p>
          <p className="text-gray-400 mb-2" style={{ fontFamily: "'Poppins', sans-serif" }}>
            58 avenue Raymond Aron, 91300 Massy
          </p>
          <div className="flex justify-center gap-6 text-gray-400 mb-6" style={{ fontFamily: "'Poppins', sans-serif" }}>
            <a href="tel:+33768304656" className="hover:text-[#D4A85F] transition-colors">07 68 30 46 56</a>
            <a href="tel:+33169307853" className="hover:text-[#D4A85F] transition-colors">01 69 30 78 53</a>
          </div>
          <div className="border-t border-gray-800 pt-6">
            <a 
              href="/" 
              className="text-[#3ABEFF] hover:text-[#D4A85F] transition-colors"
              style={{ fontFamily: "'Poppins', sans-serif" }}
            >
              ← Retour au restaurant PLANETE FOOD
            </a>
          </div>
          <p className="text-gray-500 text-sm mt-6" style={{ fontFamily: "'Poppins', sans-serif" }}>
            © {new Date().getFullYear()} AFRICAN DREAM. Tous droits réservés.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default TraiteurPage;
